import {Feature, Features} from "../feature";

export const alcoholFilter = {
    filterInPlace: (features: Feature[]) => {
        const carbAcids = features.filter(f => f.name.includes(Features.carbAcid))
        const alcohols = features.filter(f => f.name.includes(Features.alcohol))

        carbAcids.forEach(acid => {
            const childAlcohol = alcohols.find(alc => alc.atoms.every(a => acid.atoms.includes(a)))
            if(childAlcohol) {
                features.splice(features.indexOf(childAlcohol), 1);
            }
        })
        return features;
    }
}